import script from "./app-share-model.vue?vue&type=script&setup=true&lang=js"
export * from "./app-share-model.vue?vue&type=script&setup=true&lang=js"

import "./app-share-model.vue?vue&type=style&index=0&id=50f40bdf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50f40bdf"]])

export default __exports__